module.exports = __webpack_public_path__ + "assets/img/29_301_big.69f3ee24.jpg";